import axios from "axios";

const BOERSENNEWS_BASE_URL = "https://www.boersennews.de";

export interface TopTopicByIsin {
  perfRel: number;
  title: string;
  target: string;
}

interface BoersennewsResponse {
  cStatus: boolean;
  cSuccess: boolean;
  data: { perfRel: string | number; title: string; target: string }[];
  msg?: string;
}

export const getTopTopicsByIsin = async (
  isinList: string[],
  limit: number
): Promise<TopTopicByIsin[]> => {
  const body = new URLSearchParams({
    isinList: isinList.join(","),
    limit: String(limit),
  });

  const { data } = await axios.post<BoersennewsResponse>(
    `${BOERSENNEWS_BASE_URL}/ajax/topic/top-by-isin/`,
    body
  );

  if (!data.cStatus || !data.cSuccess) {
    throw new Error(data.msg ?? "Boersennews request failed");
  }

  return data.data.map((topic) => ({
    ...topic,
    perfRel: Number(topic.perfRel),
  }));
};
